<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="7.2" height="1.2" viewBox="0 0 7.2 1.2">
		<line
			id="Line_703"
			data-name="Line 703"
			x2="6"
			transform="translate(0.6 0.6)"
			fill="none"
			stroke="#5a677d"
			stroke-linecap="round"
			stroke-width="1.2"
		/>
	</svg>
</template>

<script>
export default {
	name: 'RemoveSvg',
};
</script>

<style scoped lang="scss"></style>
